import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { usePageMeta } from '../services/seo';

// Standard public page shell: header, optional hero band, content, footer
const PageShell = ({ title, description, path, eyebrow, heading, intro, children, testId, dark = true, wide = false }) => {
  usePageMeta({ title, description, path });
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <Header />
      {(heading || eyebrow) && (
        <section className={`${dark ? 'bg-[#0e0e10] text-white' : 'bg-white text-gray-900 border-b'} relative overflow-hidden`} data-testid={testId ? `${testId}-hero` : undefined}>
          <div className="absolute -right-24 -top-24 w-80 h-80 rounded-full bg-orange-500/20 blur-3xl pointer-events-none" />
          <div className="absolute -left-16 bottom-0 w-64 h-64 rounded-full bg-[#1e3a5f]/40 blur-3xl pointer-events-none" />
          <div className={`${wide ? 'max-w-7xl' : 'max-w-5xl'} mx-auto px-4 py-10 sm:py-14 relative`}>
            {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.2em] text-orange-400 mb-3">{eyebrow}</p>}
            {heading && <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-3xl">{heading}</h1>}
            {intro && <p className={`mt-4 text-base md:text-lg max-w-2xl ${dark ? 'text-gray-300' : 'text-gray-600'}`}>{intro}</p>}
          </div>
        </section>
      )}
      <main className={`${wide ? 'max-w-7xl' : 'max-w-5xl'} mx-auto px-4 py-8 sm:py-12 flex-1 w-full`} data-testid={testId}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PageShell;
